import * as React from 'react';
import { VmsFavoriteToggler } from './VmsFavoriteToggler';
import { Vms } from './VmsMenu';

export interface IVmsItemProps {
    vms: Vms;
    currentRegion: string;
    isfavorite: boolean;
    renderAsLink?: boolean;
}

export class VmsItem extends React.Component<IVmsItemProps> {
    constructor(props: IVmsItemProps) {
        super(props);
    }

    public render(): JSX.Element {
        const items = this.props.vms;

        return <div className="details-card traffic-sign-details">{this.renderItemContent.apply(this, [items])}</div>;
    }

    private renderImage(source: string, text: string): JSX.Element {
        return (
            <div className="icon-area">
                <img className="sign-icon" alt={text ?? ''} src={source} />
                {text != null && text !== undefined && text.length > 0 ? (
                    <div className="road-sign-text-container">
                        <span className="road-sign-text">{text}</span>
                    </div>
                ) : null}
            </div>
        );
    }

    private renderTextArea(text1: string, text2: string, text3: string): JSX.Element {
        return (
            <div className="text-area">
                <span className="text-row" dangerouslySetInnerHTML={{ __html: text1 }} />
                <span className="text-row" dangerouslySetInnerHTML={{ __html: text2 }} />
                <span className="text-row" dangerouslySetInnerHTML={{ __html: text3 }} />
            </div>
        );
    }

    private renderSmallItem(item: Vms): JSX.Element {
        let content: JSX.Element;

        const image = () => {
            return item.messageSignSource != null && item.messageSignVisible ? this.renderImage(item.messageSignSource, item.roadSignText) : null;
        };

        if (item.noMessageRowVisible) {
            content = <div className="no-message-row">INGET MEDDELANDE</div>;
        } else {
            content = image();
        }

        return (
            <div className="sign-item-container">
                <div className="sign-item">
                    {content}
                    {item.noMessageRowVisible ? null : this.renderTextArea(item.textRow1, item.textRow2, item.textRow3)}
                </div>
            </div>
        );
    }

    private renderDoubleItem(item: Vms): JSX.Element {
        const imageFirst = () => {
            return item.messageSignSource != null ? this.renderImage(item.messageSignSource, item.roadSignText) : null;
        };

        const imageSecond = () => {
            return item.messageSignSource != null ? this.renderImage(item.connectedMessageSignSource, item.connectedRoadSignText) : null;
        };

        let content: JSX.Element;

        if (item.noMessageRowVisible && item.connectedNoMessageRowVisible) {
            content = (
                <div className="sign-item height-50">
                    <div className="no-message-row">INGET MEDDELANDE</div>
                </div>
            );
        } else {
            content = (
                <div className="sign-item height-50">
                    {imageFirst()}
                    {this.renderTextArea(item.textRow1, item.textRow2, item.textRow3)}
                </div>
            );
        }

        return (
            <div className="sign-item-container">
                {content}
                {item.connectedNoMessageRowVisible ? (
                    <div className="sign-item height-50">
                        {imageSecond()}
                        {this.renderTextArea(item.connectedTextRow1, item.connectedTextRow2, item.connectedTextRow3)}
                    </div>
                ) : null}
            </div>
        );
    }

    private renderBigItem(item: Vms): JSX.Element {
        let content: JSX.Element = null;
        let wrapperClass = 'sign-item';

        if (item.noMessageRowVisible) {
            content = <div className="no-message-row">INGET MEDDELANDE</div>;
            wrapperClass += ' top';
        }

        return (
            <div className="sign-item-container">
                {item.noMessageRowVisible ? <div className="sign-item" /> : null}
                <div className={wrapperClass}>
                    {content}
                    {content == null && item.messageSignSource != null && item.messageSignVisible ? (
                        <img className="sign-icon" alt="ikon" src={item.messageSignSource} />
                    ) : null}
                    {content == null &&
                    item.messageSignSource !== null &&
                    item.messageSignVisible &&
                    item.roadSignText !== undefined &&
                    item.roadSignText !== null &&
                    item.roadSignText.length > 0 ? (
                        <div className="road-sign-text-container">
                            <span className="road-sign-text">{item.roadSignText}</span>
                        </div>
                    ) : null}
                </div>
                {item.noMessageRowVisible ? null : (
                    <div className="sign-item">
                        <span className="text-row" dangerouslySetInnerHTML={{ __html: item.textRow1 }} />
                        <span className="text-row" dangerouslySetInnerHTML={{ __html: item.textRow2 }} />
                        <span className="text-row" dangerouslySetInnerHTML={{ __html: item.textRow3 }} />
                    </div>
                )}
            </div>
        );
    }

    private renderItemContent(item: Vms): JSX.Element {
        const wrapperClass = 'sign-link ' + (item.vmsCssClass == null ? '' : item.vmsCssClass);
        const figcaption = item.publicName == null ? item.name : item.publicName;

        let content: JSX.Element;

        if (item.vmsCssClass === 'small') {
            content = this.renderSmallItem.apply(this, [item]);
        }
        if (item.vmsCssClass === 'big double') {
            content = this.renderDoubleItem.apply(this, [item]);
        }
        if (item.vmsCssClass === 'big') {
            content = this.renderBigItem.apply(this, [item]);
        }
        const figureClass = 'content ' + (item.vmsCssClass == null ? '' : item.vmsCssClass);

        return (
            <figure className={figureClass}>
                <figcaption>
                    <span>{figcaption}</span>
                </figcaption>
                {this.props.renderAsLink ? (
                    <a className={wrapperClass} href={item.url}>
                        {content}
                    </a>
                ) : (
                    <div className={wrapperClass}>{content}</div>
                )}
                <div className="d-flex align-items-center justify-content-end caption-container">
                    <div className="favorite_toggler">
                        <VmsFavoriteToggler currentVmsId={item.id.toString()} currentRegion={this.props.currentRegion} />
                    </div>
                </div>
            </figure>
        );
    }
}
